export const getters = {
    getBanco: state => state.banco,
    getBancos: state => state.bancos,
    getModalCadastroBanco: state => state.modalCadastrarBanco,
    getModalExcluirBanco: state => state.modalExcluirBanco,
    getModalPesquisarBanco: state => state.modalPesquisarBanco
}

export default {}